import PurchaseStatus from "./purchase-status";

const locale = {
  jp: {
    [PurchaseStatus.Created]: "未発注",
    [PurchaseStatus.Ordered]: "発注済み",
    [PurchaseStatus.Paid]: "送金済み",
    [PurchaseStatus.Invalid]: "無効"
  }
};

export default {
  toJp(key: string): string {
    return locale.jp[key] || "";
  }
};
